import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Vejica } from '../../components/vd/LineArt';

const AurikulotherapyPage = () => (
  <main className="pb-16" data-testid="page-program-aurikuloterapija">
    <Helmet>
      <title>Podpora mamici – aurikuloterapija – Val Dotika</title>
      <meta name="description" content="Aurikuloterapija za mamice – nežna stimulacija izbranih točk na ušesu kot podpora pri stresu, utrujenosti in poporodnem okrevanju." />
    </Helmet>

    <section className="pt-14 sm:pt-20 pb-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Vejica size={56} className="text-olive-700 mx-auto mb-6 vd-line-anim" />
        <h1 className="font-serif italic text-4xl sm:text-5xl lg:text-6xl text-vd-text mb-4">Tudi mamica potrebuje malo podpore</h1>
      </div>
    </section>

    <section className="pb-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl border border-olive-100 p-6 sm:p-10 space-y-5 text-vd-text/90 leading-relaxed">
          <p>Ko prideš z dojenčkom na srečanje, ne želim, da je ves čas namenjen samo njemu. Tudi ti si pomembna. Zato je v vsako srečanje vključena <span className="font-semibold">aurikuloterapija</span> – nežna stimulacija izbranih točk na ušesu. In brez skrbi, nič ne bova špikali. 😊</p>
          <p>Mamice jo pogosto izberejo takrat, ko so utrujene, pod stresom, težko zares izklopijo ali preprosto čutijo, da potrebujejo nekaj zase.</p>
          <div className="pt-2 border-t border-olive-100">
            <p className="font-semibold text-olive-800">Aurikuloterapija je vključena v ceno vsakega srečanja.</p>
            <p className="text-xs text-vd-muted mt-2">Priznava jo tudi Svetovna zdravstvena organizacija (WHO).</p>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default AurikulotherapyPage;
